export default "__VITE_ASSET__B0Oj4FzU__"